import { connect } from 'react-redux'
import MessageList from '../../components/MessageList';

const mapStateToProps = state => {
  return {
    messages: state.advisory.messages
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

// The container grants access to redux state from the message list component.
const Messages = connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageList)

export default Messages



// WEBPACK FOOTER //
// ./src/containers/Messages/index.js